import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => props.automation, []) // eslint-disable-line react-hooks/exhaustive-deps
}
